import React from 'react';
import { motion } from 'framer-motion';
export const CHECKOUT_URL = 'https://chikung-latam.impultienda.ar/checkout/completo';
export const PRICE_USD = '19 €';
export const PRICE_USD_FULL = '47 €';
export const PRICE_USD_NEXT = '27 €';
export const Section = ({
  children,
  className = '',
  id = '',
  glow = false
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 24
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6,
  ease: [0.23, 1, 0.32, 1]
}} className={`relative pt-2 pb-14 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full bg-transparent ${className}`} data-id="element-226" data-mp="ai6un31magkd">
    {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-227" data-mp="pcbcqkyllyek">
        <div className="absolute -top-16 left-[18%] w-[420px] h-[420px] max-w-[70vw] rounded-full bg-brand-goldLight/40 blur-[120px] animate-aurora-1" data-id="element-228" data-mp="20tbe062xbnkq" />
        <div className="absolute -bottom-20 right-[16%] w-[380px] h-[380px] max-w-[70vw] rounded-full bg-brand-gold/25 blur-[120px] animate-aurora-2" data-id="element-229" data-mp="39j7zruap8129" />
        <div className="absolute top-1/2 left-1/2 w-[560px] h-[320px] max-w-[85vw] rounded-full bg-brand-greenSage/25 blur-[130px] animate-aurora-halo" data-id="element-230" data-mp="30itakjum61th" />
        <div className="absolute top-0 left-1/2 w-[70%] h-full bg-brand-goldLight/20 blur-2xl animate-beam" data-id="element-231" data-mp="2vmcf14l34l6d" />
      </div>}
    {children}
  </motion.section>;
export const SectionHeading = ({
  eyebrow,
  children,
  className = ''
}: {
  eyebrow?: string;
  children: React.ReactNode;
  className?: string;
}) => <div className={`text-center ${className}`} data-id="element-232" data-mp="2ctqmou9dzcqj">
    {eyebrow && <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark mb-3" data-id="element-233" data-mp="2cvl8sbwe9aw7">
        {eyebrow}
      </p>}
    <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-purpleDark leading-tight" data-id="element-234" data-mp="22vkoonqpaqqy">
      {children}
    </h2>
    <div className="gold-rule mt-5" aria-hidden="true" data-id="element-235" data-mp="1t7p0q8s6dui3">
      <span className="text-brand-gold text-[10px]" data-id="element-236" data-mp="1tab8a8f2ga0b">◆</span>
    </div>
  </div>;
export const CTAButton = ({
  children,
  href,
  className = '',
  fullWidth = false,
  variant = 'purple',
  style
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
  style?: React.CSSProperties;
}) => {
  const bgClass = variant === 'purple' ? 'purple-gradient-bg text-brand-surface' : 'gold-gradient-bg text-brand-purpleDark';
  const shadowClass = variant === 'purple' ? 'shadow-[0_14px_30px_-16px_rgba(126,44,33,0.85)] hover:shadow-[0_18px_38px_-16px_rgba(126,44,33,0.95)]' : 'shadow-[0_14px_30px_-16px_rgba(138,107,39,0.7)] hover:shadow-[0_18px_38px_-16px_rgba(138,107,39,0.85)]';
  const classes = `inline-flex items-center justify-center text-center mx-auto px-8 py-4 text-base font-semibold tracking-wide uppercase ${bgClass} rounded-full ${shadowClass} transition-shadow duration-200 ease-out cursor-pointer ${fullWidth ? 'w-full' : ''} ${className}`;
  return <motion.a href={href ?? CHECKOUT_URL} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.15,
    ease: [0.23, 1, 0.32, 1]
  }} className={classes} style={style} data-id="element-237" data-mp="j9fkqpja798a">
      {children}
    </motion.a>;
};